/** checkin — EN source (120 keys). */
export const checkin = {
  checkin_launcher_subtitle:
    "Check into a nearby Linqx event to connect, play, and earn CP — open Check In to get started.",
  checkin_launcher_open_button: "Check In",
  checkin_map_title: "Check In",
  checkin_map_tap_event: "Tap an event on the map to check in",
  checkin_map_no_nearby: "No Linqx events nearby right now.",
  checkin_map_location_denied:
    "Location is off. Enable it to find nearby events, or scan a QR.",
  checkin_map_you_are_here: "You are here",
  checkin_map_scan_instead: "Scan to Check In",
  checkin_card_check_in_button: "Check In",
  checkin_card_scan_button: "Scan to Check In",
  checkin_card_try_again_button: "Try Again",
  checkin_card_potential_linqx: "{count} potential Linqx",
  checkin_card_geofence_error:
    "You're not at the venue yet — about {distance}m away. Get closer and try again.",
  checkin_scan_title: "New Check In",
  checkin_scan_point_camera: "Point your camera at the event QR code.",
  checkin_scan_camera_help:
    "Enable the camera to scan, or paste the event code below.",
  checkin_scan_enable_camera: "Enable Camera",
  checkin_scan_paste_placeholder: "Paste event code",
  checkin_scan_submit: "Check In",
  checkin_scan_checking_in: "Checking in…",
  checkin_scan_invalid_code: "That doesn't look like an event check-in code.",
  checkin_back: "Back",
  checkin_back_to_dashboard: "Back to Dashboard",
  checkin_activity_coming_soon: "This activity is coming soon.",
  checkin_dashboard_checked_in: "Checked In!",
  checkin_dashboard_cp_amount: "+{cp} CP",
  checkin_dashboard_qr_connect: "QR Connect",
  checkin_dashboard_activities: "Activities",
  checkin_dashboard_top_mixers: "Top Mixers",
  checkin_dashboard_see_full_board: "See Full Board",
  checkin_dashboard_no_active: "You're not checked into an event yet.",
  checkin_dashboard_back_to_map: "Back to Map",
  checkin_activity_speed_linq: "Speed Linq",
  checkin_activity_mini_games: "Mini-Games",
  checkin_activity_photo: "Photo Challenge",
  checkin_activity_social_share: "Social Share",
  checkin_activity_invite: "Invite Friends",
  checkin_action_play: "Play",
  checkin_action_join: "Join",
  checkin_action_camera: "Camera",
  checkin_action_share: "Share",
  checkin_action_invite: "Invite",
  checkin_photo_title: "Photo Challenge",
  checkin_photo_timeline_hint: "Event timeline · earn +10 CP per photo",
  checkin_photo_empty: "No photos yet. Be the first to share one!",
  checkin_photo_just_now: "just now",
  checkin_photo_take: "Take photo",
  checkin_photo_cap_reached: "You've shared all 3 of your photos.",
  checkin_photo_remaining: "{count} photos left",
  checkin_photo_report: "Report",
  checkin_photo_reported: "Photo reported.",
  checkin_photo_submitting: "Uploading…",
  checkin_leaderboard_title: "Top Mixers",
  checkin_leaderboard_empty:
    "No mixers ranked yet. Earn CP to climb the board!",
  checkin_leaderboard_finalized: "Final results",
  checkin_leaderboard_updates: "Updates every 2 min",
  checkin_leaderboard_pts: "{count} pts",
  checkin_leaderboard_you: "You",
  checkin_invite_title: "Invite Friends",
  checkin_invite_heading: "Invite friends, earn 25 CP",
  checkin_invite_subtitle:
    "Get +25 CP each time a friend joins with your code and finishes setting up.",
  checkin_invite_your_code: "Your referral code",
  checkin_invite_copy: "Copy Code",
  checkin_invite_copied: "Copied ✓",
  checkin_invite_how_it_works: "How it works",
  checkin_invite_step_1: "Share your code with a friend",
  checkin_invite_step_2: "They enter it when they sign up",
  checkin_invite_step_3: "They finish onboarding",
  checkin_invite_step_4: "You get +25 CP",
  checkin_invite_footnote:
    "Events referral — copy-code only. Credits show in Points History.",
  checkin_games_title: "Mini-Games",
  checkin_games_join_heading: "Join a Game",
  checkin_games_code_placeholder: "Enter code to join",
  checkin_games_join_button: "Join Game →",
  checkin_games_live_heading: "Live now at this event",
  checkin_games_join: "Join",
  checkin_games_type_who_said_it: "Who Said It?",
  checkin_games_type_two_truths: "Two Truths & a Lie",
  checkin_games_status_lobby: "Waiting for players…",
  checkin_games_status_in_progress: "In progress",
  checkin_games_players: "{count} players",
  checkin_games_code_label: "Code {code}",
  checkin_games_empty:
    "No games running yet — the organizer hasn't started one.",
  checkin_games_organizer_note: "Games are started by the organizer",
  checkin_games_joining: "Joining…",
  checkin_game_title_who_said_it: "Who Said It?",
  checkin_game_title_two_truths: "Two Truths & a Lie",
  checkin_game_round: "Round {current}/{total}",
  checkin_game_waiting: "Waiting for the round to start…",
  checkin_game_prompt_who_said_it: "Who said it?",
  checkin_game_prompt_two_truths: "Which one is the lie?",
  checkin_game_your_score: "Your score {score}",
  checkin_game_next: "Next →",
  checkin_game_finish: "Finish →",
  checkin_game_over: "Game over",
  checkin_game_final_score: "Final score {score}",
  checkin_game_completed: "completed",
  checkin_game_completed_winner: "completed + winner",
  checkin_game_capped: "Daily game CP cap reached",
  checkin_game_back_to_event: "Back to Event",
  checkin_game_ended: "This game has ended.",
  checkin_game_dropped: "You were dropped from the game — no CP awarded.",
  checkin_speed_title: "Speed Linq",
  checkin_speed_intro_heading: "60 seconds. Tap fast.",
  checkin_speed_intro_body:
    "Like the people you'd want to meet before the timer runs out. Earn +10 CP for playing.",
  checkin_speed_start: "Start",
  checkin_speed_like: "Like",
  checkin_speed_skip: "Skip",
  checkin_speed_already_liked: "Liked",
  checkin_speed_time_left: "{seconds}s",
  checkin_speed_empty: "No one else to meet here yet — check back soon.",
  checkin_speed_done_heading: "Time's up!",
  checkin_speed_liked_count: "You liked {count} people",
  checkin_speed_done: "Done",
  checkin_share_title: "Share this event",
  checkin_share_subtitle: "#LinqxMixer · earn +25 CP when you return",
  checkin_share_shared_heading: "Shared! Come back to claim",
  checkin_share_credited_note: "(credited on return, once per event)",
  checkin_share_done: "Done",
  checkin_share_already: "You've already claimed this event's share CP.",
};
